import { INITIAL_LETTER_OF_FOREIGN_IDENTIFICATION_NUMBER, INITIAL_LETTER_OF_NATIONAL_REGISTRATION_CARD_NUMBER } from '../../constants/sgp/profileDetails';

export const isNationalRegistrationCardNumber = (idNumber: string | null | undefined) => {
  return !idNumber ? false : INITIAL_LETTER_OF_NATIONAL_REGISTRATION_CARD_NUMBER.includes(idNumber.charAt(0));
};

export const isForeignIdentificationNumber = (idNumber: string | null | undefined) => {
  return !idNumber ? false : INITIAL_LETTER_OF_FOREIGN_IDENTIFICATION_NUMBER.includes(idNumber.charAt(0));
};
